import { Badge, Box, Link, Stack, Typography } from "@mui/material";

const isUrl = (value: string | undefined): boolean =>
  typeof value === 'string' && /^https?:\/\//i.test(value.trim());

export interface BageBoxProps {
  index: number,
  items: {label: string, value?: string}[],
  valueTextFontSize: any,
  blackTextColor: any,
  titleBadge: string
}

const BadgeBox = ({
  index,
  items,
  valueTextFontSize,
  blackTextColor,
  titleBadge
}: BageBoxProps) => (
  <Stack 
    direction="column"
    mt={2}
    spacing={1}
    key={index} 
    sx={{
      border: "1px solid",
      borderColor: "#919eab3d",
      borderRadius: 1,
      padding: '8px'
    }}
  >
    <Badge 
      badgeContent={`${titleBadge} ${index + 1}`}
      anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
      }}
      sx={{
        "& .MuiBadge-badge": {
          transform: "scale(1) translate(0%, -80%)",
          backgroundColor: '#fff'
        },
      }}
    >
    </Badge>
    {items?.map((item) => {
      const value = item?.value ?? "";
      const showAsLink = isUrl(value);
      const valueWrapSx = {
        flex: 1,
        minWidth: 0,
        overflowWrap: 'break-word' as const,
        wordBreak: 'break-all' as const,
      };
      return (
        <Box key={`box-b-${index}-${item?.label}`} sx={{ display: 'flex', flexDirection: 'row'}}>
          <Typography sx={[valueTextFontSize, { flex: 0.4 , color: '#637381', flexShrink: 0 }]}>
            {item?.label ?? ""}
          </Typography>
          {showAsLink ? (
            <Link
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              sx={[
                valueTextFontSize,
                {
                  ...valueWrapSx,
                  color: 'primary.main',
                  textDecoration: 'underline',
                  fontSize: '0.8rem',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                },
              ]}
            >
              {value}
            </Link>
          ) : (
            <Typography sx={[valueTextFontSize, blackTextColor, valueWrapSx]}>
              {value}
            </Typography>
          )}
        </Box>
      );
    })}
  </Stack>
);

export default BadgeBox;